export enum ImportsTabsEnum {
  IMPORTS_PEOPLE = 'peopleImports',
  IMPORTS_BUSINESS = 'businessImports',
  IMPORTS_NEW = 'newImports'
}
